import React, { forwardRef, ReactNode, RefObject } from 'react';

import { Props as ContainerProps } from './types';

import './course-container-banner.scss';

interface BannerProps extends ContainerProps {
    children: ReactNode;
    className: string;
}

export const CourseContainerBanner = forwardRef(function CourseContainerBanner(
    { courseContainer, className, children }: BannerProps,
    ref: RefObject<HTMLDivElement>
) {
    const { color } = courseContainer.container;

    return (
        <div className={className} style={{ backgroundColor: color || undefined }}>
            <div className="course-container-banner__resize-block" ref={ref} />
            <div className="course-container-banner__content-container">{children}</div>
        </div>
    );
});
